/**
 * ResetPasswordPage — legacy URL.
 *
 * The reset flow now lives at /forgot-password as a single-page wizard.
 * Users who land here (from an old email link or a bookmark) get a brief
 * glass card before the redirect fires, so the transition doesn't flash
 * a blank screen on top of the auth gradient.
 */

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spinner } from '../../components/ui'
import { AuthShell, AuthGlassCard } from '../../components/auth'

export default function ResetPasswordPage() {
  const navigate = useNavigate()
  useEffect(() => {
    const id = setTimeout(() => navigate('/forgot-password', { replace: true }), 200)
    return () => clearTimeout(id)
  }, [navigate])

  return (
    <AuthShell variant="centered">
      <AuthGlassCard className="max-w-md mx-auto text-center">
        <Spinner size="lg" className="mx-auto mb-4" />
        <p className="text-sm text-ink-secondary">
          Redirecting to password reset…
        </p>
      </AuthGlassCard>
    </AuthShell>
  )
}
